import * as React from 'react';

import { SuperAgentBadge } from '../SuperAgentBadge';
import { SuperAgentTooltip } from '../SuperAgentTooltip';

type TSuperAgentLevelViewProps = {
  levelName: string;
  tooltipText: string;
};

export const SuperAgentLevelView: React.FC<TSuperAgentLevelViewProps> = ({ levelName, tooltipText }) => {
  if (!tooltipText.length) {
    return <SuperAgentBadge levelName={levelName} />;
  }

  return (
    <SuperAgentTooltip tooltipText={tooltipText}>
      <SuperAgentBadge levelName={levelName} />
    </SuperAgentTooltip>
  );
};
